import { QRCodeSVG } from "qrcode.react";
import type { MfaEnrollment } from "../mfa-enrollment";

export function AuthenticatorEnrollment({
  enrollment,
  email,
}: {
  enrollment: MfaEnrollment;
  email: string;
}) {
  return (
    <section
      className="mfa-enrollment"
      aria-label="Scan your authenticator QR code"
    >
      <h3>1. Add this account to your authenticator</h3>
      <p className="mfa-account">
        ZentroTax — <strong>{email}</strong>
      </p>
      <p>In your authenticator app, choose Add account, then Scan QR code.</p>
      <div className="mfa-qr">
        <QRCodeSVG
          value={enrollment.otpauthUri}
          size={240}
          marginSize={4}
          level="M"
          bgColor="#FFFFFF"
          fgColor="#000000"
          role="img"
          title={`Authenticator setup QR code for ${email}`}
        />
      </div>
      <p>
        Add a separate entry for this account. A code from another account or an
        earlier setup will not work here. Keep this QR code private.
      </p>
      <details className="mfa-secret">
        <summary>Can't scan? Enter a setup key instead</summary>
        <p>
          Choose Enter a setup key in your app. Use the account email above and
          select Time based (6 digits, 30 seconds).
        </p>
        <code>{enrollment.secret}</code>
      </details>
      <h3>2. Verify the code from this new entry</h3>
      <p>
        Enter the current 6-digit code below. Setup expires after 10 minutes.
        The app generates a new code every 30 seconds.
      </p>
    </section>
  );
}
